// extracted by mini-css-extract-plugin
export default {"fileName":"c3Xg3brh0m"};